import React from 'react'
import Common from '../../utils/common';
import { Redirect, Route, Switch } from "react-router";

export default class Landing extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            activePage: 15
        }

        var paramId = this.props.match.params.id;
        var param = {};
        var paramKeyword = this.props.match.params.keyword;

        var page = this.props.match.params.page;
        var hash = window.location.hash;
        
        if(hash != "" && page == undefined)
        {
            console.log(hash);
            page = parseInt(hash.substring(1));
        }

        if(page == undefined || page == NaN)
        {
            page = 1;
        }

        console.log(this.props.match.params);
        param['paramId'] = paramId;
        param['friendlyUrl'] = this.props.match.params.friendlyUrl;
        
        if (paramKeyword == undefined) {
            var url = new URL(window.location.href);
            paramKeyword = url.searchParams.get("keyword");
        }
        param['paramKeyword'] = paramKeyword;
        if (this.props.match.params.name != undefined) {
            window.location.href = "/" + this.props.match.params.language + "/pages/" + this.props.match.params.name;
        }
        this.state.build = Common.getPage('landing', param,page);
    }
    componentDidMount() {
    }
    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    render() {
        //console.log(this.state.string);


        window.html += "<main id='"+this.props.match.params.friendlyUrl+"'  merchantCode='"+window.merchantCode +"'>" + this.state.build + "</main>";
        return (

            <main id={this.props.match.params.friendlyUrl} merchantCode={window.merchantCode}>
                <div dangerouslySetInnerHTML={{ __html: this.state.build }}></div>
            </main>

        )

    }

}

